
import React, { useMemo } from "react";
import ReactQuill from "react-quill";
// import ReactQuill from "react-quill";
// const ReactQuill = dynamic(import("react-quill"), { ssr: false });
import "react-quill/dist/quill.snow.css";

export default function CustomTextAreaInput({
    value = "",
    onChange = () => {},
    BoxStyle = {},
    placeholder = "",
    inputHeight = "75%",
  }) {
  return (
    <div className="w-[100%] h-[300px] rounded-lg p-1 bg-white">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        style={{ height: 200, fontFamily: "Kanit" }}
        placeholder={'enter text'}
      />
    </div>
  )
}
